import { UserManager } from "oidc-client";
import config from "authconfig";

const userManager = new UserManager(config);

export const login = () => {
  userManager.signinRedirect();
};

export const logout = () => {
  userManager.signoutRedirect();
};

export const handleCallback = () => {
  return userManager.signinRedirectCallback();
};

// export const handleCallback = async () => {
//   try {
//     console.log("Handling callback...");
//     const user = await userManager.signinRedirectCallback();
//     console.log("User info:", user);
//     return user;
//   } catch (error) {
//     console.error("Error during sign-in callback:", error);
//     throw error;
//   }
// };

export const getUser = () => {
  return userManager.getUser();
};
